let MOBACT_URL, FACECHK_URL, FACEREG_URL;

if (window.env && window.env.MOBACT_URL) {
  MOBACT_URL = window.env.MOBACT_URL;
  FACECHK_URL = window.env.FACECHK_URL;
  FACEREG_URL = window.env.FACEREG_URL;
} else {
  throw new Error("Problem in getting ENV File");
}


export const config = (data) => {
  return {
    method: "post",
    url: MOBACT_URL,
    mode: "no-cors",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: data,
  };
};

export const config2 = (data) => {
  return {
    method: "post",
    url: FACECHK_URL,
    mode: "no-cors",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: data,
  };
};

// export const config3 = (data, url, empId, apiKey) => {
//   return {
//     method: "post",
//     url: `${url}api/v1/recognition/faces?subject=${empId}`,
//     mode: "no-cors",
//     headers: {
//       "Content-Type": "application/json",
//       Accept: "application/json",
//       "x-api-key": apiKey,
//     },
//     data: data,
//   };
// };

export const config3 = (data, url, empId, apiKey) => {
  return {
    method: "post",
    url: FACEREG_URL,
    mode: "no-cors",
    headers: {
      "Content-Type": "multipart/form-data",
    },
    data: data
  };
};
